module.exports = __webpack_public_path__ + "static/Fred_Meyer_pin-4f39ffde06dad915f05bd0fc90f89201.png";